module.exports = __webpack_public_path__ + "static/inspiration-follow-feed-animated-3ece14fc44786dceea37f4aae80b455f.gif";